import { TableCellText } from '@pocketlaw/tetris';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { DesktopTableBodyCell } from '../styled';
export function DateCell(props) {
    const { date } = props;
    const formattedDate = localizedFormatDate(date);
    return (<DesktopTableBodyCell headers="created_at">
      <TableCellText primary={formattedDate}/>
    </DesktopTableBodyCell>);
}
